import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomConfirmDialog } from '../../../../../../components/dialogs'
import { RoleAssignment } from '../../../data'

type Props = {
  onClickHandler: () => void
  role: RoleAssignment['role']
  assignee: RoleAssignment['assignee']
  project: RoleAssignment['project']
  isVisible: boolean
  onHide: () => void
}

export const DeleteAssignee: React.FC<Props> = ({
  onClickHandler,
  isVisible,
  role,
  assignee,
  project,
  onHide,
}) => {
  const { t } = useTranslation()

  const message = (
    <>
      <p>
        {t('roleAssignments.table.delete.dialog.description', {
          assignee: assignee,
          role: role,
        })}
      </p>
      <strong>{assignee}</strong>
      <br />
      {role}
      <br />
      {project}
    </>
  )

  return (
    <CustomConfirmDialog
      severity="danger"
      isVisible={isVisible}
      header={t('roleAssignments.table.delete.dialog.title')}
      message={message}
      onHide={onHide}
      onReject={onHide}
      rejectLabel={t('roleAssignments.table.delete.dialog.cancel.label')}
      onAccept={onClickHandler}
      acceptLabel={t('roleAssignments.table.delete.dialog.delete.label')}
    />
  )
}
